import React, {useEffect, useState} from "react";
import "./HomeHeader.css";
import SimpleLineIcon from 'react-simple-line-icons';
import {useDispatchNav, useNav} from "../../hooks";
import {useHistory} from "react-router-dom";
import {useMall} from "../../hooks/useMall";
import Logo from '../../assets/images/logo.png';


function HomeHeader() {

    const setNav = useDispatchNav();
    const nav = useNav();
    const history = useHistory();
    const Mall = useMall();

    const [localLogo,setLocalLogo] = useState("")

    useEffect(()=>{
        let loc = localStorage.getItem('mallLogo');
        // console.log("Notif : ",Notification.permission)
        setLocalLogo(loc?loc:'/other/brand.png');
    },[])

    return(
        <div className="header_container">
            <div className="header_sec3" onClick={()=>{
                    history.push("/notifications")
                }}>
                <SimpleLineIcon name="bell" />
            </div>
            <div className="header_sec2"><img className="brand_logo" src={Logo} /></div>
            <div className="header_sec1"
                 onClick={()=>{
                   setNav(!nav);
                 }}
            ><img className="svg_icon" src="/svg/menu_icon.svg" alt=""/></div>
        </div>
    )
}

export {HomeHeader};
